import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHandle, updateHandle } from './actions';
import { useNavigate, useParams } from 'react-router-dom';
import HandleEditForm from './HandleEditForm';
import Paper from '@mui/material/Paper';
import { Typography, Box } from '@mui/material';
import { mainPageRootStyle } from '../styles';
import SkeletonForm from '../components/SkeletonForm';
import Breadcrumb from '../components/Breadcrumb';

const HandleEditPage = () => {
    const [handle, setHandle] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { handleId } = useParams();

    const handleRedux = useSelector(state => state.handle.handle);

    useEffect(() => {
        document.title = 'Edit Handle - Sky Toolbox';
    }, []);

    useEffect(() => {
        dispatch(getHandle(handleId));
    }, [handleId, dispatch]);

    useEffect(() => {
        if (handleRedux) {
            setHandle({ ...handleRedux });
        }
    }, [handleRedux]);

    const handleHandleChange = useCallback(a => {
        setHandle(a);
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        dispatch(updateHandle(handleId, handle, navigate));
    }, [handleId, handle, navigate, dispatch]);

    const isLoading = !handle;

    return (
        <Paper style={mainPageRootStyle} sx={{ p: 3 }}>
            <Breadcrumb items={[
                { label: 'Handles', path: '/handles' },
                { label: 'Edit Handle' }
            ]} />
            
            {/* Page Header */}
            <Box 
                sx={{ 
                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    borderRadius: 3,
                    p: 3,
                    mb: 4,
                    color: 'white',
                }}
            >
                <Typography variant="h4" component="h1" fontWeight="bold" sx={{ mb: 1 }}>
                    ✏️ Edit Handle
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Update your BlueSky account details
                </Typography>
            </Box>
            
            {isLoading ? (
                <SkeletonForm fields={[
                    { height: 56 },
                    { height: 56 },
                    { height: 60, width: '20%' }
                ]} />
            ) : (
                <HandleEditForm
                    handleSubmit={handleSubmit}
                    handle={handle}
                    handleHandleChange={handleHandleChange}
                />
            )}
        </Paper>
    );
};

export default HandleEditPage;
